import type { GameView } from '@mt/protocol';
import { secondsLeft } from '../lib/format';
import { stageTitle } from '../lib/variants';
import { t } from '../i18n';

/**
 * Шаги трека этапов; функция, а не константа — подписи на текущем языке.
 * open — «Открытые карты»: круги называются по решению (направление, пункты), а не по раскрытию.
 */
const steps = (open: boolean): { id: GameView['stage'][]; label: string; hint: string }[] => [
  open
    ? { id: ['round1'], label: t('table.stage.open.r1'), hint: t('table.stage.open.r1Hint') }
    : { id: ['round1'], label: t('table.stage.chart'), hint: t('table.stage.chartHint') },
  open
    ? { id: ['round2'], label: t('table.stage.open.r2'), hint: t('table.stage.open.r2Hint') }
    : { id: ['round2'], label: t('table.stage.scale'), hint: t('table.stage.scaleHint') },
  open
    ? { id: ['round3'], label: t('table.stage.open.r3'), hint: t('table.stage.open.r3Hint') }
    : { id: ['round3'], label: t('table.stage.composition'), hint: t('table.stage.compositionHint') },
  { id: ['locked'], label: t('table.stage.candle'), hint: t('table.stage.candleHint') },
  { id: ['settled', 'cancelled'], label: t('table.stage.settle'), hint: t('table.stage.settleHint') },
];

export function StageTrack({ game, now, nextStartAt = null }: { game: GameView; now: number; nextStartAt?: number | null }) {
  const STEPS = steps(!!game.instrument);
  const idx = game.stage === 'prep' ? -1 : STEPS.findIndex((s) => s.id.includes(game.stage));
  const finished = game.stage === 'settled' || game.stage === 'cancelled';
  // после расчёта таймер показывает время до следующего розыгрыша
  const left = finished ? secondsLeft(nextStartAt, now) : secondsLeft(game.stageEndsAt, now);
  const total = game.stage === 'prep' ? null : game.minuteMs;
  const frac = game.stageEndsAt && total ? Math.min(1, Math.max(0, (game.stageEndsAt - now) / total)) : 0;
  const urgent = left !== null && left <= 10 && game.stage.startsWith('round');
  return (
    <div className="stage-track">
      <ol>
        {STEPS.map((s, i) => (
          <li key={s.label} className={i < idx ? 'done' : i === idx ? 'current' : ''}>
            <span className="label">{s.label}</span>
            <span className="hint">{s.hint}</span>
            {i === idx && total !== null && game.stageEndsAt && <span className="bar" style={{ transform: `scaleX(${frac})` }} />}
          </li>
        ))}
      </ol>
      <div className={`stage-timer ${urgent ? 'urgent' : ''}`} aria-live="polite">
        <div className="stage-name">{finished && nextStartAt ? t('table.stage.nextIn') : stageTitle(game.stage, !!game.instrument)}</div>
        <div className="stage-sec mono">{left === null ? '—' : `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`}</div>
      </div>
    </div>
  );
}
